/* eslint-disable @typescript-eslint/no-unused-vars */
import classnames from 'classnames'
// import dynamic from 'next/dynamic'
// import { useState } from 'react'
import { useRouter } from 'next/router'
// import Link from '../Common/Link'
// import { useAnalyticsEvent } from '@/hooks/analytics/use-analytics-event'
import { getAppsFlyerLink } from './helper'
import { GA4Event } from '@/root/utils/common/web/gtm-events/types'
import { useAnalyticsEvent } from '@/hooks/analytics/use-analytics-event'

// const LoginWidget = dynamic(() => import('../Common/LoginWidget'), {
//   ssr: false,
// })

export const GreenButton = ({
  btnText,
  addclassName,
  navLink = '/',
  withLogin,
  postLoginNavlink = '',
  eventAction = '',
  overrideClassname,
  appsflyerBtn = false,
  id = '',
  onClickCallback,
  clickEventData,
  isIndStocks = false,
}: {
  btnText: string
  addclassName?: string
  navLink?: string
  withLogin?: boolean
  postLoginNavlink?: string
  eventAction?: string
  overrideClassname?: string
  appsflyerBtn?: boolean
  id?: string
  onClickCallback?: () => void
  clickEventData?: GA4Event
  isIndStocks?: boolean
}) => {
  // const [openModal, setOpenModal] = useState(false)
  // const pushEvent = useAnalyticsEvent()

  const router = useRouter()
  const { push } = router
  const pushEvent = useAnalyticsEvent()
  return (
    <button
      id={id}
      className={classnames(
        'btn bg-brand-green-dark w-full px-2.5 py-3 text-base font-medium lg:w-[330px] lg:px-6 lg:py-4 lg:text-lg',
        addclassName,
      )}
      onClick={() => {
        if (onClickCallback) onClickCallback()
        if (clickEventData) {
          pushEvent({
            gtm4Payload: {
              eventData: { ...clickEventData, eventLabel: btnText },
            },
          })
        }

        const link = getAppsFlyerLink(router, btnText, isIndStocks)
        void push(link)
      }}
    >
      {btnText}
    </button>
  )

  // Can be uncommented when logged in state is smooth (as per Ashish)

  // return withLogin ? (
  //   <>
  //     {openModal && (
  //       <LoginWidget
  //         openModal={openModal}
  //         onClose={() => setOpenModal(false)}
  //         postLoginNavlink={postLoginNavlink}
  //       />
  //     )}
  //     <button
  //       className={classnames(
  //         {
  //           'btn bg-brand-green-dark w-full px-6 py-3 text-base font-medium lg:w-[330px] lg:py-4 lg:text-lg':
  //             !overrideClassname,
  //         },
  //         addclassName,
  //         overrideClassname,
  //       )}
  //       onClick={() => {
  //         if (eventAction) {
  //           pushEvent({
  //             gaPayload: {
  //               eventAction,
  //               eventCategory: 'login_bottomsheet',
  //               eventLabel: '',
  //               eventValue: pathname,
  //             },
  //           })
  //         }
  //         setOpenModal(true)
  //       }}
  //     >
  //       {btnText}
  //     </button>
  //   </>
  // ) : appsflyerBtn ? (
  //   <button
  //     className={classnames(
  //       'btn bg-brand-green-dark w-full px-6 py-3 text-base font-medium lg:w-[330px] lg:py-4 lg:text-lg',
  //       addclassName,
  //     )}
  //     onClick={() => {
  //       const lob = getLineOfBusiness(pathname).split(' ').join('-')
  //       const ctaLabel = btnText.split(' ').join('-')

  //       const link = `${
  //         window.AF_SMART_SCRIPT_RESULT?.clickURL ?? ONE_LINK_thumb_cta_web
  //       }&page_lob=${lob}&cta_label=${ctaLabel}`
  //       void push(link)
  //     }}
  //   >
  //     {btnText}
  //   </button>
  // ) : (
  //   <Link href={navLink} title={btnText}>
  //     <button
  //       className={classnames(
  //         'btn bg-brand-green-dark w-full px-6 py-3 text-base font-medium lg:w-[330px] lg:py-4 lg:text-lg',
  //         addclassName,
  //       )}
  //     >
  //       {btnText}
  //     </button>
  //   </Link>
  // )
}
